import { getProjectByCodeOrId } from '../api/simple-project-service/projects/getProjectByCodeOrId';
import { FAKE_USER_ID_PREFIX } from '../constants';
import { Configuration } from '../interfaces/Configuration';
import { getWindow } from './windowService';

const wnd = getWindow();

const projectsUrl = '/projects';
const salesProjectsUrl = '/sales-projects';
const draftsUrl = '/drafts';

/** @deprecated – use react history.replace */
export const redirectToConfigurationCode = (configurationCode: string) => {
  if (!configurationCode) {
    return;
  }

  const urlParts = wnd.location.pathname.split('/').filter((part) => !!part);
  const currentConfigurationUrlIdentifier = urlParts.pop();

  if (configurationCode !== currentConfigurationUrlIdentifier) {
    wnd.history.replaceState(null, '', `/configurator/${configurationCode}`);
  }
};

export const getSmartProjectDashboardLink = async (
  configuration: Configuration,
  loggedInUserId: string,
  isAdminUser: boolean,
): Promise<string> => {
  if (!configuration) {
    return isAdminUser ? salesProjectsUrl : projectsUrl;
  }

  if (configuration.isDraft()) {
    if (loggedInUserId === configuration.creator) {
      return `${draftsUrl}#${configuration.id}`;
    }
    return projectsUrl;
  }

  const projectCode = configuration.configurationCode.projectCode;

  if (!isAdminUser) {
    return `${projectsUrl}#${projectCode}`;
  }

  if (configuration.creator?.startsWith(FAKE_USER_ID_PREFIX)) {
    return `${salesProjectsUrl}#${configuration.configurationCode.projectCode}`;
  }

  const project = await getProjectByCodeOrId(projectCode).catch<Error>();

  return project instanceof Error
    ? getUrlBasedOnCreator(configuration.creator === loggedInUserId, projectCode)
    : getUrlBasedOnCreator(project.createdBy === loggedInUserId, projectCode);
};

const getUrlBasedOnCreator = (isCreator: boolean, code: string): string => {
  return isCreator ? `${projectsUrl}#${code}` : `${salesProjectsUrl}#${code}`;
};

export const getMyProjectUrl = (projectCode: string): string => {
  return `${projectsUrl}#${projectCode}`;
};
